import * as React from 'react'
import { useState } from 'react'
import { Card, Tabs } from 'antd'
import { VerificationHistories } from '../VerificationHistories'
import { VerificationDuplicates } from '../VerificationDuplicates'
import { useVerificationRequestsWidget } from '../../atoms/duplicates/hooks'

type Props = {
  clientId: string
  requestId: string
}

export const VerificationTabs = ({ clientId, requestId }: Props) => {
  const { verificationRequest } = useVerificationRequestsWidget(requestId)
  const duplicatesCount = verificationRequest?.length ?? 0
  const [selectedDuplicate, setSelectedDuplicate] = useState<{
    clientId: string
    requestId: string
  } | null>(null)

  const items = [
    {
      key: 'history',
      label: 'History',
      children:
        clientId !== '' ? (
          <VerificationHistories clientId={clientId} requestId={requestId} />
        ) : null,
    },
    {
      key: 'duplicates',
      label: (
        <>
          Duplicates
          {duplicatesCount > 0 && (
            <span
              style={{
                color: '#ff4d4f',
                fontSize: '1.25em',
                fontWeight: 700,
                marginLeft: 4,
              }}
            >
              ({duplicatesCount})
            </span>
          )}
        </>
      ),
      children:
        requestId !== '' ? (
          <VerificationDuplicates
            clientId={requestId}
            selectedRequestId={selectedDuplicate?.requestId ?? null}
            onSelect={setSelectedDuplicate}
          />
        ) : null,
    },
  ]

  return (
    <>
      <Card className="mb-4" size="small">
        <Tabs
          defaultActiveKey="history"
          destroyInactiveTabPane
          items={items}
          onChange={() => setSelectedDuplicate(null)}
        />
      </Card>
      {selectedDuplicate && (
        <Card className="mb-4">
          <VerificationHistories
            clientId={selectedDuplicate.clientId}
            requestId={selectedDuplicate.requestId}
          />
        </Card>
      )}
    </>
  )
}
